import {Component, OnInit, Injector, AfterViewInit, Input, OnDestroy} from '@angular/core';
import {IchWizardpointType, wizardSaved} from '../interfaces/scanner.interfaces';
import {ScannerSide, ScannerPrimarySearchList} from '../interfaces/scanner.enums';
import {AppComponentBase} from '../../../services/AppComponentBase';

@Component({
    selector: 'app-scanner-chWizardSelector',
    template: require('./scanner-chWizardSelector.component.html'),
    styles: [require('./scanner-chWizardSelector.component.scss')]
})
export class ScannerChWizardSelectorComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {


    public _narrowScannerMode: boolean = false;

    @Input() public set narrowScannerMode(value: boolean) {
        this._narrowScannerMode = value
        if(value == true) {
            this.workspace.scannerCurrentRule_Narrow = undefined;
        }
    }

    public get narrowScannerMode() {
        return this._narrowScannerMode;
    }

    public subscribers: any = {};
    ngAfterViewInit(): void {

        let v = this.workspace.initLoadScan;
        if(v != null) {
            this.loadScanData(v);
            //  this.workspace.initLoadScan = null;
        }

    }

    ngOnDestroy() {
        //  this.subscribers.load.unsubscribe();
    }
    constructor(injector: Injector) {
        super(injector);

        this.workspace.globaGridMode.loadScannerRule.subscribe(v => {

            //   if(v.primary == ScannerPrimarySearchList.SCANNER_WIZARD)
            this.loadScanData(v)

        });
        this.allowScanProcess();

    }


    public loadScanData(v: any) {

        let loadScanData: wizardSaved = (!this.narrowScannerMode) ? <wizardSaved> v.savedData : <wizardSaved> v.savedDataSecondary;

        if(loadScanData.primary != ScannerPrimarySearchList.SCANNER_WIZARD) {
            return
        }

        if(loadScanData.rule.side != undefined) {
            if(!this.narrowScannerMode) {
                this.workspace.scannerSearch_side = loadScanData.rule.side
            }
            else {
                this.workspace.scannerSearch_Narrow_side = loadScanData.rule.side
            }
        }

        this.workspace.scannerSearch_period = loadScanData.period


        switch(loadScanData.rule.side) {
            case ScannerSide.SCANNER_SIDE_BUY:
                if(loadScanData.rule.selectedPoints != undefined) {
                    this.setPointNumBuy(loadScanData.rule.selectedPoints)
                }
                break;

            case ScannerSide.SCANNER_SIDE_SELL:
                if(loadScanData.rule.selectedPoints != undefined) {
                    this.setPointNumSell(loadScanData.rule.selectedPoints)
                }
                break;
        }

        this.workspace.canSelectedSavedScanUpdate = false;
        this.workspace.allowScanProcess = true;
    }


    ngOnInit() {

        this.allowScanProcess();
    }


    public get scannerSearch_side(): ScannerSide | string {

        if(!this.narrowScannerMode) {

            if(this.selectedTypeOfPoint.side != this.workspace.scannerSearch_side) {
                this.selectedTypeOfPoint.selectedPoints = 0;
            }

            this.allowScanProcess();
            return this.workspace.scannerSearch_side
        }
        else {
            if(this.selectedTypeOfPoint.side != this.workspace.scannerSearch_Narrow_side) {
                this.selectedTypeOfPoint.selectedPoints = 0;
            }

            return this.workspace.scannerSearch_Narrow_side
        }
    }



    private _selectedTypeOfPoint: IchWizardpointType = {};
    public get selectedTypeOfPoint(): IchWizardpointType {
        return this._selectedTypeOfPoint;
    }
    public set selectedTypeOfPoint(value: IchWizardpointType) {
        this._selectedTypeOfPoint = value;
    }

    public setPointNumBuy(v: number) {
        this.selectedTypeOfPoint = {side: ScannerSide.SCANNER_SIDE_BUY, selectedPoints: v}
        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = this.selectedTypeOfPoint;
        }
        else {
            this.workspace.scannerCurrentRule_Narrow = this.selectedTypeOfPoint;
        }

        this.allowScanProcess()
    }

    public setPointNumSell(v: number) {
        this.selectedTypeOfPoint = {side: ScannerSide.SCANNER_SIDE_SELL, selectedPoints: v}

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = this.selectedTypeOfPoint;
        }
        else {
            this.workspace.scannerCurrentRule_Narrow = this.selectedTypeOfPoint;
        }

        this.allowScanProcess()
    }

    public scannerSide = ScannerSide;

    public loop: number[] = [1, 2, 3, 4]



    public allowScanProcess() {
        if(!this.narrowScannerMode) {
            if(
                this.selectedTypeOfPoint.selectedPoints == 0 || this.workspace.scannerSearch_period == "NO" || this.workspace.scannerSearch_side == "NO"
            ) {
                this.workspace.allowScanProcess = false;
            }
            else {
                this.workspace.allowScanProcess = true;
            }
        }
        else {
            if(
                this.selectedTypeOfPoint.selectedPoints == 0 || this.workspace.scannerSearch_period == "NO" || this.workspace.scannerSearch_side == "NO"
            ) {
                this.workspace.allowScanProcessNarrow = false;
            }
            else {
                this.workspace.allowScanProcessNarrow = true;
            }
        }

    }



    //NARROW SCANNER
    public get scannerSearch_Narrow_side(): ScannerSide | string {
        if(this.selectedTypeOfPoint.side != this.workspace.scannerSearch_Narrow_side) {
            this.selectedTypeOfPoint.selectedPoints = 0;
        }

        this.allowScanProcess();
        return this.workspace.scannerSearch_Narrow_side
    }



    public onShown(e: any) {

    }



}


